import { TableCell } from "@mui/material";
import { IDeltaHedgeAccountAggregateReport } from "../../../../Interfaces/deltaHedgeAccounts";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../../TableTemplate/tableTemplate";
import Button from "../../../../Components/Button";
import { useState, useMemo } from "react";
import ChartUI from "./ChartUI";
import Modal from "../../../../Components/Modal/Modal";
import TimelineIcon from "@mui/icons-material/Timeline";
// Local Component
import PreferredBorderChart from "./PreferredBorderChart";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">نمودار حساسیت</span>
      </TableCell>
      <TableCell>
        <span className="!font-black text-black">مرز ترجیحی </span>
      </TableCell>
    </>
  );
};

enum ModalType {
  sensivity,
  preferredBorder,
  closed,
}
const AdditionalCol: React.FC<{
  row: IDeltaHedgeAccountAggregateReport;
}> = ({ row }) => {
  const [modalType, setModalType] = useState(ModalType.closed);

  const ChartModal = useMemo(() => {
    switch (modalType) {
      case ModalType.sensivity:
        return <ChartUI row={row} />;
      case ModalType.preferredBorder:
        return <PreferredBorderChart row={row} />;
      default:
        return <></>;
    }
  }, [modalType]);

  return (
    <>
      {modalType !== ModalType.closed ? (
        <Modal
          UI={ChartModal}
          title={
            modalType === ModalType.sensivity ? "نمودار حساسیت" : "مرز ترجیحی"
          }
          onClose={() => setModalType(ModalType.closed)}
          fullScreen
        />
      ) : (
        <></>
      )}
      <TableCell>
        <div className="py-1 px-2">
          <Button
            text={
              <>
                <TimelineIcon style={{ fontSize: 16 }} /> حساسیت
              </>
            }
            onClick={() => setModalType(ModalType.sensivity)}
            variant="contained"
            className="table-btn px-5"
          />
        </div>
      </TableCell>
      <TableCell>
        <div className="py-1 px-2">
          <Button
            text={
              <>
                <TimelineIcon style={{ fontSize: 16 }} /> مرز ترجیحی
              </>
            }
            onClick={() => setModalType(ModalType.preferredBorder)}
            variant="contained"
            className="table-btn px-5"
          />
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IDeltaHedgeAccountAggregateReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
